import React from 'react'
import { Parallax } from 'react-parallax';
import Image1 from '../../Gemco-Website-Images/projects/Museum_of_the_Future.webp';
import '../Project.css';

const Project_two = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>Museum of the Future</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>A 78-metre torus-shaped architectural icon developed by Dubai Future Foundation, rated one of the world's most complex
                buildings. Designed by Killa Design, the museum houses immersive innovation experiences across 7 floors and serves as a
                global landmark for future-focused technology and design. Opened 2022.</p>
              <p>MAIN CONTRACTOR : BAM International</p>
              <p>MEP CONTRACTOR : Transgulf</p>
              <p>GEMCO SCOPE OF WORKS : CHW, electrical and ducting — construction phase
                through to live operations; retrofit, fitout and AMC works</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>
  )
}

export default Project_two